import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css?__remix_sideEffect__";
import {
  Box,
  Flex,
  HStack,
  Spacer,
  VStack,
  Wrap,
  WrapItem } from
"@chakra-ui/react";
import { TaskScreenStyles } from "../../../pages/task/TaskScreenStyles";
import { MobileTaskCardStyles } from "../task/MobileTaskCardStyles";
import { SubjectFilterComponentStyles } from "../../../pages/task/SubjectFilterComponentStyles";

const MobileTaskCardSkeleton = ({ count = 20 }) => {
  return (
    <>
      <Box width={"100%"} overflowX={"auto"}>
        <Box sx={SubjectFilterComponentStyles()?.mainContainer}>
          {[...Array(4)].map((_, index) =>
          <Skeleton
            key={index}
            height="40px"
            width="100px"
            borderRadius="20px" />

          )}
        </Box>
      </Box>
      <Box sx={TaskScreenStyles()?.taskCardContainer} bgColor={"#E9E5FF"}>
        <VStack sx={TaskScreenStyles()?.taskCardSection}>
          <Skeleton height={30} width="40%" style={{ marginBottom: "1rem" }} />
          <Wrap sx={TaskScreenStyles()?.taskCardWrapContainer}>
            {[...Array(count)].map((_, index) =>
            <WrapItem key={index} sx={TaskScreenStyles()?.cardSuperContainer}>
                <Box sx={MobileTaskCardStyles()?.mainContainer}>
                  <HStack sx={MobileTaskCardStyles()?.topContainer}>
                    <VStack sx={MobileTaskCardStyles()?.detailsContainer}>
                      <Flex sx={MobileTaskCardStyles()?.topLine}>
                        <HStack
                        sx={MobileTaskCardStyles()?.completionContainer}>

                          <Skeleton
                          height="20px"
                          width="100px"
                          sx={MobileTaskCardStyles()?.completionText} />

                          <Skeleton
                          height="20px"
                          width="60px"
                          sx={MobileTaskCardStyles()?.inTimeDate} />

                        </HStack>
                        <Spacer />
                        <Skeleton
                        height="20px"
                        width="40px"
                        sx={MobileTaskCardStyles()?.gpIcon} />

                        <Skeleton
                        height="30px"
                        width="30px"
                        sx={MobileTaskCardStyles()?.subjectIcon} />

                      </Flex>
                      <Skeleton
                      height="20px"
                      width="200px"
                      sx={MobileTaskCardStyles()?.taskTitle} />

                    </VStack>
                  </HStack>
                  <HStack sx={MobileTaskCardStyles()?.bottomContainer}>
                    <Skeleton
                    height="20px"
                    width="20px"
                    borderRadius="full"
                    sx={MobileTaskCardStyles()?.bottomText} />

                    <Skeleton
                    height="20px"
                    width="150px"
                    sx={MobileTaskCardStyles()?.bottomText} />

                  </HStack>
                </Box>
              </WrapItem>
            )}
          </Wrap>
        </VStack>
      </Box>
    </>);

};

export default MobileTaskCardSkeleton;